import {
  GET_PERSONAL,
  GET_ALL_EDIFICIOS,
  GET_ALL_TIPOS_WFH,
  GET_PROFESIONALES_SITIOS,
  GET_HORARIOS_PROFESIONAL,
  ADD_APPOINTMENT,
  CANCEL_APPOINTMENT,
  GET_APPOINTMENT,
  MEA_LOADING,
  MEA_PRUEBA,
  GET_APPOINTMENT_BY_STATE,
  GET_DIAGNOSTICOS,

  GET_ES_DOCTOR,
  GET_ES_PUESTO,
  GET_HEALTH_CAMPAIGN,
  GET_ALL_HEALTH_CAMPAIGN,
  ADD_HEALTH_CAMPAIGN,
  UPDATE_HEALTH_CAMPAIGN,
  DELETE_HEALTH_CAMPAIGN,
  MEA_GET_IMAGE,
  GET_IMAGES_HEALTH_CAMPAIGN,
  MEA_GET_REQUEST_TYPE,
  MEA_GET_EMPLOYEES_SIIS,
  MEA_ADD_SELF_MANAGEMENT,
  MEA_GET_AREA_CUENTA,
  MEA_ALL_SELF_MANAGEMENTS,
  MEA_GET_SELF_MANAGEMENT,
  MEA_SEND_EMAIL,
  MEA_UPDATE_SELF_APPOIMENT,
  MEA_HABILITAR_CITA,
  MEA_HABILITAR_CITA_AUTOGESTION,
  MEA_UPDATE_OPEN_BUILDING,
  MEA_GET_BUILDING,
  MEA_GET_ONE_EMPLOYEE_SIIS,
} from "../actions/MedicalAppointment";


const initialState = {
  afiliado: [],
  edificios: [],
  tiposWFH: [],
  profesionales: [],
  horarios: [],
  appointmentAdd: '',
  appointmentCancel: '',
  appointments: [],
  diagnostics: [],
  HealthCampaigns: [],
  ImagesHealthCampaigns: [],
  HealthCampaign: null,
  HealthCampaignAdd: false,
  HealthCampaignUpdate: false,
  HealthCampaignDelete: false,
  image: null,
  loading: false,
  add: false,
  esDoctor: false,
  esPuesto: false,
  prueba: '',
  RequestType: [],
  Building:null,
  EmployeesSiis: [],
  AreaCuenta: [],
  SelfManagmentAdd: false,
  ListSelfManagments: [],
  GetSelfManagment: [],
  sendEmail: false,
  habilitarCita: false,
  habilitarCitaAutogestion: false,
  updateActive:false,
  updateAppoiment: false,
  Employee: null
};

const MedicalAppointment = function (state = initialState, action) {
  switch (action.type) {
    case MEA_LOADING: {
      return {
        ...state,
        loading: true,
        add: false
      };
    }


    case GET_ES_DOCTOR: {
      return {
        ...state,
        esDoctor: action.data,
        loading: false,
        add: false,
      }
    }


    case GET_ES_PUESTO: {
      return {
        ...state,
        esPuesto: action.data,
        loading: false,
        add: false,
      }
    }

    case GET_HEALTH_CAMPAIGN: {
      return {
        ...state,
        HealthCampaign: action.data,
        loading: false,
        add: false,
      }

    }
    case GET_ALL_HEALTH_CAMPAIGN: {
      return {
        ...state,
        HealthCampaigns: [...action.data],
        loading: false,
        add: false,
      }
    }
    case GET_IMAGES_HEALTH_CAMPAIGN: {
      return {
        ...state,
        ImagesHealthCampaigns: [...action.data],
        loading: false,
        add: false,
      }
    }

    case ADD_HEALTH_CAMPAIGN: {
      return {
        ...state,
        HealthCampaignAdd: action.data,
        loading: false,
        add: true,
      }
    }
    case UPDATE_HEALTH_CAMPAIGN: {
      return {
        ...state,
        HealthCampaignUpdate: action.data,
        loading: false,
        add: true,
      }
    }
    case DELETE_HEALTH_CAMPAIGN: {
      return {
        ...state,
        HealthCampaignDelete: action.data,
        loading: false,
        add: true,
      }
    }

    case GET_ALL_EDIFICIOS: {
      return {
        ...state,
        edificios: [...action.data],
        loading: false,
        add: false,
      }
    }

    case GET_ALL_TIPOS_WFH: {
      return {
        ...state,
        tiposWFH: [...action.data],
        loading: false,
        add: false,
      }
    }
    case GET_PROFESIONALES_SITIOS: {
      return {
        ...state,
        profesionales: [...action.data],
        loading: false,
        add: false,
      }
    }
    case GET_HORARIOS_PROFESIONAL: {
      return {
        ...state,
        horarios: [...action.data],
        loading: false,
        add: false,
      }
    }
    case GET_PERSONAL: {
      return {
        ...state,
        afiliado: [...action.data],
        loading: false,
        add: false,
      }
    }
    case GET_APPOINTMENT: {
      return {
        ...state,
        appointments: [...action.data],
        loading: false,
        add: false,
      }
    }
    case GET_APPOINTMENT_BY_STATE: {
      return {
        ...state,
        appointments: [...action.data],
        loading: false,
        add: false,
      }
    }
    case GET_DIAGNOSTICOS: {
      return {
        ...state,
        diagnostics: [...action.data],
        loading: false,
        add: false,
      }
    }
    case ADD_APPOINTMENT: {
      return {
        ...state,
        appointmentAdd: action.data,
        add: true,
        loading: false
      };
    }
    case CANCEL_APPOINTMENT: {
      return {
        ...state,
        appointmentCancel: [...action.data],
        add: true,
        loading: false
      };
    }

    case MEA_GET_IMAGE: {
      return {
        ...state,
        image: action.data,
        add: false,
        loading: false
      };
    }

    case MEA_PRUEBA: {
      return {
        ...state,
        prueba: action.data,
        loading: false
      };
    } 

    case MEA_GET_BUILDING: {
      return {
        ...state,
        Building: action.data,
        loading: false
      };
    } 
    case MEA_GET_REQUEST_TYPE: {
      return {
        ...state,
        RequestType: [...action.data],
        loading: false
      };
    } 
    case MEA_GET_EMPLOYEES_SIIS: {
      return {
        ...state,
        EmployeesSiis: [...action.data],
        loading: false
      };
    } 
    case MEA_GET_AREA_CUENTA: {
      return {
        ...state,
        AreaCuenta: [...action.data],
        loading: false
      };
    }  
    
    case MEA_ALL_SELF_MANAGEMENTS: {
      return {
        ...state,
        ListSelfManagments: [...action.data],
        loading: false
      };
    }  

    
    case MEA_GET_SELF_MANAGEMENT: {
      return {
        ...state,
        GetSelfManagment: action.data,
        loading: false
      };
    }   
    
    case MEA_HABILITAR_CITA: {
      return {
        ...state,
        habilitarCita: action.data,
        loading: false
      };
    }   
     
    
    case MEA_HABILITAR_CITA_AUTOGESTION: {
      return {
        ...state,
        habilitarCitaAutogestion: action.data,
        loading: false
      };
    }   
    
    case MEA_SEND_EMAIL: {
      return {
        ...state,
        sendEmail: action.data,
        loading: false
      };
    }   
    case MEA_ADD_SELF_MANAGEMENT: {
      return {
        ...state,
        SelfManagmentAdd: action.data,
        loading: false
      };
    }
    case MEA_UPDATE_SELF_APPOIMENT: {
      return {
        ...state,
        updateAppoiment: action.data,
        loading: false
      };
    }
    case MEA_UPDATE_OPEN_BUILDING: {
      return {
        ...state,
        updateActive: action.data,
        loading: false
      };
    }
    case MEA_GET_ONE_EMPLOYEE_SIIS: {
      return {
        ...state,
        Employee: action.data,
        loading: false
      };
    }
    default: {
      return state;
    }
  } 
}

export default MedicalAppointment;
